import React from "react";
import "../DesignerPropertiesPanel.css";

const TextProperties = ({ selectedObject, updateObjectDataField }) => {
  const dataJson = selectedObject.data_json || {};

  return (
    <div className="dp-section">
      <h4 className="dp-section-title">Content</h4>

      <div className="dp-field">
        <label className="dp-label">Text</label>
        <textarea
          value={dataJson.text || ""}
          onChange={(e) =>
            updateObjectDataField(selectedObject.id, "text", e.target.value)
          }
          rows={4}
          className="dp-textarea"
        />
      </div>
    </div>
  );
};

export default TextProperties;